import React from "react";
import { IconProps } from "./IconProps";

const ArrowLeftIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.2475 9.63H4.7075L9.4775 4.86C9.6775 4.66 9.6775 4.35 9.4775 4.15C9.2775 3.95 8.9675 3.95 8.7675 4.15L3.1475 9.78C3.1475 9.78 3.0675 9.88 3.0375 9.94C2.9875 10.06 2.9875 10.2 3.0375 10.32C3.0675 10.38 3.0975 10.44 3.1475 10.48L8.7675 16.1C8.8675 16.2 8.9975 16.25 9.1175 16.25C9.2375 16.25 9.3775 16.2 9.4675 16.1C9.6675 15.9 9.6675 15.59 9.4675 15.39L4.7075 10.63H17.2475C17.5275 10.63 17.7475 10.41 17.7475 10.13C17.7475 9.85 17.5275 9.63 17.2475 9.63Z"
            fill={color}
          />
        </svg>
      );
    case "24Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.0006 11.5004C21.0006 11.6993 20.9216 11.8901 20.7809 12.0307C20.6403 12.1714 20.4495 12.2504 20.2506 12.2504H5.5609L11.0312 17.7198C11.1009 17.7895 11.1562 17.8722 11.1939 17.9632C11.2316 18.0543 11.251 18.1519 11.251 18.2504C11.251 18.349 11.2316 18.4465 11.1939 18.5376C11.1562 18.6286 11.1009 18.7114 11.0312 18.781C10.9615 18.8507 10.8788 18.906 10.7878 18.9437C10.6967 18.9814 10.5991 19.0008 10.5006 19.0008C10.402 19.0008 10.3045 18.9814 10.2134 18.9437C10.1224 18.906 10.0396 18.8507 9.96996 18.781L3.21996 12.031C3.15023 11.9614 3.09491 11.8787 3.05717 11.7876C3.01943 11.6966 3 11.599 3 11.5004C3 11.4019 3.01943 11.3043 3.05717 11.2132C3.09491 11.1222 3.15023 11.0394 3.21996 10.9698L9.96996 4.21979C10.1107 4.07906 10.3016 4 10.5006 4C10.6996 4 10.8905 4.07906 11.0312 4.21979C11.1719 4.36052 11.251 4.55139 11.251 4.75042C11.251 4.94944 11.1719 5.14031 11.0312 5.28104L5.5609 10.7504H20.2506C20.4495 10.7504 20.6403 10.8294 20.7809 10.9701C20.9216 11.1107 21.0006 11.3015 21.0006 11.5004Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.75 16C27.75 16.1989 27.671 16.3897 27.5303 16.5303C27.3897 16.671 27.1989 16.75 27 16.75H6.81125L14.53 24.47C14.6037 24.5387 14.6628 24.6215 14.7038 24.7135C14.7448 24.8055 14.7668 24.9048 14.7686 25.0055C14.7704 25.1062 14.7518 25.2062 14.7141 25.2996C14.6764 25.393 14.6203 25.4778 14.549 25.549C14.4778 25.6203 14.393 25.6764 14.2996 25.7141C14.2062 25.7518 14.1062 25.7704 14.0055 25.7686C13.9048 25.7668 13.8055 25.7448 13.7135 25.7038C13.6215 25.6628 13.5387 25.6037 13.47 25.53L4.47 16.53C4.32955 16.3894 4.25066 16.1987 4.25066 16C4.25066 15.8012 4.32955 15.6106 4.47 15.47L13.47 6.47C13.6122 6.33752 13.8002 6.2654 13.9945 6.26882C14.1888 6.27225 14.3742 6.35096 14.5116 6.48838C14.649 6.62579 14.7277 6.81118 14.7312 7.00548C14.7346 7.19978 14.6625 7.38782 14.53 7.53L6.81125 15.25H27C27.1989 15.25 27.3897 15.329 27.5303 15.4697C27.671 15.6103 27.75 15.8011 27.75 16Z"
            fill={color}
          />
        </svg>
      );
    case "32Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28 16C28 16.2652 27.8946 16.5196 27.7071 16.7071C27.5196 16.8947 27.2652 17 27 17H7.41374L14.7075 24.2925C14.8004 24.3854 14.8741 24.4957 14.9244 24.6171C14.9747 24.7385 15.0005 24.8686 15.0005 25C15.0005 25.1314 14.9747 25.2615 14.9244 25.3829C14.8741 25.5043 14.8004 25.6146 14.7075 25.7075C14.6146 25.8004 14.5043 25.8741 14.3829 25.9244C14.2615 25.9747 14.1314 26.0006 14 26.0006C13.8686 26.0006 13.7385 25.9747 13.6171 25.9244C13.4957 25.8741 13.3854 25.8004 13.2925 25.7075L4.29249 16.7075C4.19952 16.6146 4.12576 16.5043 4.07543 16.3829C4.02511 16.2615 3.99921 16.1314 3.99921 16C3.99921 15.8686 4.02511 15.7385 4.07543 15.6171C4.12576 15.4957 4.19952 15.3854 4.29249 15.2925L13.2925 6.29251C13.4801 6.10487 13.7346 5.99945 14 5.99945C14.2654 5.99945 14.5199 6.10487 14.7075 6.29251C14.8951 6.48015 15.0005 6.73464 15.0005 7.00001C15.0005 7.26537 14.8951 7.51987 14.7075 7.70751L7.41374 15H27C27.2652 15 27.5196 15.1054 27.7071 15.2929C27.8946 15.4804 28 15.7348 28 16Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ArrowLeftIcon;
